import { GetPricingLine, ParseQuantityRange } from 'features/commerce/pricing/pricing-result';
import React from 'react';
import { Localizer } from 'services/Localizer';
import ProductPricing from 'shared/components/commerce/ProductPricing';
import { DisplayPrice, VariantPrice } from '../../../../../Roc.SharedClientApp/types/commerce/display-price';
import { useProductDetailsContext } from './ProductDetailsContext';

interface QuantityBreak {
	min: number;
	max: number;
	price: DisplayPrice<VariantPrice, VariantPrice>;
}
export function ProductPriceBreaks() {
	const {
		state: { productDetails },
	} = useProductDetailsContext();

	const getAvailablePrices = () => {
		if (productDetails.displayPricing == null) {
			return null;
		}
		const selectedPricingLineId =
			productDetails.pricingLines &&
			productDetails.pricingLines.selected &&
			productDetails.pricingLines.selected.id;
		const displayPriceLine = GetPricingLine(
			productDetails.displayPricing,
			productDetails.id,
			selectedPricingLineId,
		);
		if (displayPriceLine == undefined) {
			return null;
		}
		return displayPriceLine.prices;
	};
	const qtyRanges = new Array<QuantityBreak>();
	const availablePricing = getAvailablePrices();
	if (availablePricing == null || Object.keys(availablePricing).length == 1) {
		return null;
	}
	for (const qtyRange in availablePricing) {
		const [min, max] = ParseQuantityRange(qtyRange);
		const pricing = availablePricing[qtyRange];
		qtyRanges.push({ min: min, max: max, price: pricing });
	}
	return (
		<div>
			<table className="roc-pdp-product-pricing-table">
				<thead>
					<tr>
						<td>{Localizer('MinimumBreak')}</td>
						<td>{Localizer('MaximumBreak')}</td>
						<td>{Localizer('NetPricePerUnit')}</td>
					</tr>
				</thead>
				<tbody>
					{qtyRanges.map((qtyRange) => (
						<tr key={qtyRange.min}>
							<td>{qtyRange.max == Infinity ? <>{qtyRange.min + '+'}</> : <>{qtyRange.min}</>}</td>
							<td>{qtyRange.max == Infinity ? null : <>{qtyRange.max}</>}</td>
							<td>
								<ProductPricing displayPrice={qtyRange.price} inline testId="pdp-main-price" />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
